export default __webpack_public_path__ + "static/media/330_dummy2016-fotograf01-de.cb874a96.png";